/* FABLE theme JS — nav, reveal, lightbox + scroll theatre (parallax, drift,
   horizontal strip, stacking deck). No dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* Mobile nav ----------------------------------------------------------- */
  var toggle = document.querySelector('[data-nav-toggle]');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Reveal on scroll ------------------------------------------------------ */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealEls.forEach(function (el) {
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('revealed');
    });
  }

  /* ======================================================================
     SCROLL THEATRE
     - [data-parallax="0.1"]  vertical drift, measured against the nearest
       [data-plx-scope] ancestor (so transforms never feed back into math)
     - [data-drift="-0.14"]   horizontal drift on vertical scroll
     - .js-strip              scroll-jacked horizontal corridor (>=900px)
     - .js-deck               sticky stacking cards with scale/veil
     ====================================================================== */

  var fx = {
    parallax: [],
    drift: [],
    strips: [],
    decks: [],
    curtains: [],
    zooms: [],
    reels: [],
    fades: [],
    skews: [],
    active: false,
    raf: null,
    lastY: 0,
    vel: 0
  };

  /* Progress of a tall pinned section through the viewport: 0 when its top
     hits the top of the screen, 1 when its bottom reaches the bottom. */
  function pinProgress(scope, wh) {
    var r = scope.getBoundingClientRect();
    var travel = r.height - wh;
    if (travel <= 0) return 1;
    return clamp(-r.top / travel, 0, 1);
  }

  function scopeOf(el) {
    return el.closest('[data-plx-scope]') || el.parentElement;
  }

  function collect() {
    fx.parallax = Array.prototype.map.call(
      document.querySelectorAll('[data-parallax]'),
      function (el) {
        return { el: el, scope: scopeOf(el), speed: parseFloat(el.getAttribute('data-parallax')) || 0 };
      }
    );
    fx.drift = Array.prototype.map.call(
      document.querySelectorAll('[data-drift]'),
      function (el) {
        return { el: el, scope: scopeOf(el), factor: parseFloat(el.getAttribute('data-drift')) || 0 };
      }
    );
    fx.strips = Array.prototype.map.call(document.querySelectorAll('.js-strip'), makeStrip);
    fx.decks = Array.prototype.map.call(document.querySelectorAll('.js-deck'), makeDeck);
    fx.curtains = Array.prototype.map.call(
      document.querySelectorAll('[data-curtain]'),
      function (el) {
        return {
          el: el,
          scope: scopeOf(el),
          shape: el.getAttribute('data-curtain-shape') || 'slit'
        };
      }
    );
    fx.zooms = Array.prototype.map.call(
      document.querySelectorAll('[data-zoom]'),
      function (el) {
        return { el: el, scope: scopeOf(el), from: parseFloat(el.getAttribute('data-zoom')) || 0.5 };
      }
    );
    fx.fades = Array.prototype.map.call(
      document.querySelectorAll('[data-fade]'),
      function (el) {
        return { el: el, scope: scopeOf(el) };
      }
    );
    fx.skews = Array.prototype.map.call(
      document.querySelectorAll('[data-skew]'),
      function (el) {
        return { el: el };
      }
    );
    fx.reels = Array.prototype.map.call(document.querySelectorAll('.js-reel'), function (el) {
      return {
        el: el,
        frames: el.querySelectorAll('[data-reel-frame]'),
        count: el.querySelector('[data-reel-count]'),
        cap: el.querySelector('[data-reel-caption]'),
        idx: -1
      };
    });
  }

  function updateReel(r, wh) {
    var n = r.frames.length;
    if (!n) return;
    var p = pinProgress(r.el, wh);
    var idx = clamp(Math.floor(p * n), 0, n - 1);
    if (idx === r.idx) return;
    r.idx = idx;
    for (var i = 0; i < n; i++) {
      r.frames[i].classList.toggle('is-active', i === idx);
    }
    if (r.count) r.count.textContent = pad(idx + 1);
    if (r.cap) r.cap.textContent = r.frames[idx].getAttribute('data-caption') || '';
  }

  /* --- Horizontal strip -------------------------------------------------- */

  function makeStrip(el) {
    var strip = {
      el: el,
      track: el.querySelector('[data-strip-track]'),
      bar: el.querySelector('[data-strip-bar]'),
      count: el.querySelector('[data-strip-count]'),
      panels: el.querySelectorAll('.strip__panel'),
      jack: false,
      max: 0
    };
    // Remeasure when strip images finish loading (widths settle).
    Array.prototype.forEach.call(el.querySelectorAll('img'), function (img) {
      if (!img.complete) {
        img.addEventListener('load', function () { measureStrip(strip); }, { once: true });
      }
    });
    return strip;
  }

  function measureStrip(s) {
    var jack = window.innerWidth >= 900 && fx.active;
    s.jack = jack;
    s.el.classList.toggle('strip--jacked', jack);
    if (jack) {
      s.max = Math.max(0, s.track.scrollWidth - window.innerWidth);
      s.el.style.height = s.max + window.innerHeight + 'px';
    } else {
      s.el.style.height = '';
      s.track.style.transform = '';
      if (s.bar) s.bar.style.width = '';
      Array.prototype.forEach.call(s.panels, function (p) {
        var inner = p.firstElementChild;
        if (inner) inner.style.transform = '';
      });
    }
  }

  function updateStrip(s, wh, ww) {
    if (!s.jack || s.max <= 0) return;
    var rect = s.el.getBoundingClientRect();
    var progress = clamp(-rect.top / (s.el.offsetHeight - wh), 0, 1);
    var x = -progress * s.max;
    s.track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
    if (s.bar) s.bar.style.width = (progress * 100).toFixed(2) + '%';
    if (s.count) {
      var artPanels = s.panels.length - 1; /* minus lead card */
      var idx = clamp(Math.floor(progress * artPanels) + 1, 1, artPanels);
      s.count.textContent = pad(idx);
    }
    /* gentle tilt as panels cross the centre */
    var cx = ww / 2;
    Array.prototype.forEach.call(s.panels, function (p) {
      var inner = p.firstElementChild;
      if (!inner) return;
      var r = p.getBoundingClientRect();
      var d = (r.left + r.width / 2 - cx) / ww; /* -1 .. 1 */
      inner.style.transform =
        'rotate(' + (d * 2.4).toFixed(2) + 'deg) translateY(' + (Math.abs(d) * 26).toFixed(1) + 'px)';
    });
  }

  /* --- Stacking deck ----------------------------------------------------- */

  function makeDeck(el) {
    return { el: el, cards: el.querySelectorAll('.deck__card') };
  }

  function updateDeck(d) {
    var cards = d.cards;
    for (var i = 0; i < cards.length; i++) {
      if (i === cards.length - 1) {
        cards[i].style.setProperty('--stack', '0');
        continue;
      }
      var stickyTop = parseFloat(getComputedStyle(cards[i]).top) || 0;
      var next = cards[i + 1].getBoundingClientRect();
      var h = cards[i].offsetHeight || 1;
      var p = clamp(1 - (next.top - stickyTop) / h, 0, 1);
      cards[i].style.setProperty('--stack', p.toFixed(3));
    }
  }

  /* --- Frame loop -------------------------------------------------------- */

  function frame() {
    fx.raf = null;
    if (!fx.active) return;
    var wh = window.innerHeight;
    var ww = window.innerWidth;
    var cy = wh / 2;

    /* scroll velocity -> page "bend" */
    var y = window.scrollY || window.pageYOffset || 0;
    var dy = y - fx.lastY;
    fx.lastY = y;
    fx.vel += (dy - fx.vel) * 0.16;
    var skew = clamp(fx.vel * 0.05, -3.4, 3.4);
    fx.skews.forEach(function (it) {
      it.el.style.transform = Math.abs(skew) < 0.02 ? '' : 'skewY(' + skew.toFixed(3) + 'deg)';
    });

    fx.fades.forEach(function (it) {
      var r = it.scope.getBoundingClientRect();
      var op = clamp(1 - (-r.top) / (wh * 0.55), 0, 1);
      it.el.style.opacity = op.toFixed(3);
      it.el.style.transform = 'translateY(' + ((1 - op) * 34).toFixed(1) + 'px)';
    });

    fx.parallax.forEach(function (it) {
      var r = it.scope.getBoundingClientRect();
      var off = (r.top + r.height / 2 - cy) * it.speed;
      it.el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    });

    fx.drift.forEach(function (it) {
      var r = it.scope.getBoundingClientRect();
      var off = (r.top + r.height / 2 - cy) * it.factor;
      it.el.style.transform = 'translate3d(' + off.toFixed(1) + 'px,0,0)';
    });

    fx.strips.forEach(function (s) { updateStrip(s, wh, ww); });
    fx.decks.forEach(updateDeck);

    fx.curtains.forEach(function (it) {
      var p = pinProgress(it.scope, wh);
      if (it.shape === 'iris') {
        var r = (14 + 86 * p).toFixed(2);
        it.el.style.clipPath = 'circle(' + r + '% at 50% 45%)';
      } else {
        var slit = (46 * (1 - p)).toFixed(2);
        it.el.style.clipPath = 'inset(0 ' + slit + '% 0 ' + slit + '%)';
      }
      it.el.style.transform = 'scale(' + (1.12 - 0.12 * p).toFixed(4) + ')';
    });

    fx.zooms.forEach(function (it) {
      var p = pinProgress(it.scope, wh);
      var s = it.from + (1 - it.from) * p;
      it.el.style.transform = 'scale(' + s.toFixed(4) + ')';
    });

    fx.reels.forEach(function (r) { updateReel(r, wh); });

    /* keep ticking until the bend settles */
    if (Math.abs(fx.vel) > 0.06) queueFrame();
  }

  function queueFrame() {
    if (fx.raf === null) fx.raf = requestAnimationFrame(frame);
  }

  function measureAll() {
    fx.strips.forEach(measureStrip);
    queueFrame();
  }

  function enable() {
    if (fx.active) return;
    fx.active = true;
    measureAll();
    window.addEventListener('scroll', queueFrame, { passive: true });
    window.addEventListener('resize', measureAll);
    window.addEventListener('load', measureAll);
  }

  function disable() {
    fx.active = false;
    window.removeEventListener('scroll', queueFrame);
    window.removeEventListener('resize', measureAll);
    fx.parallax.concat(fx.drift).concat(fx.zooms).forEach(function (it) {
      it.el.style.transform = '';
    });
    fx.curtains.forEach(function (it) {
      it.el.style.clipPath = '';
      it.el.style.transform = '';
    });
    fx.vel = 0;
    fx.skews.forEach(function (it) { it.el.style.transform = ''; });
    fx.fades.forEach(function (it) {
      it.el.style.opacity = '';
      it.el.style.transform = '';
    });
    fx.reels.forEach(function (r) {
      r.idx = -1;
      Array.prototype.forEach.call(r.frames, function (f, i) {
        f.classList.toggle('is-active', i === 0);
      });
    });
    fx.strips.forEach(measureStrip); /* clears jack styles while inactive */
    fx.decks.forEach(function (d) {
      Array.prototype.forEach.call(d.cards, function (c) {
        c.style.setProperty('--stack', '0');
      });
    });
  }

  collect();
  if (!reduceMotion.matches) enable();
  var onMotionChange = function () {
    if (reduceMotion.matches) { disable(); } else { enable(); }
  };
  if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', onMotionChange);
  else if (reduceMotion.addListener) reduceMotion.addListener(onMotionChange);

  /* Lightbox -------------------------------------------------------------- */
  var triggers = Array.prototype.slice.call(
    document.querySelectorAll('[data-lightbox-trigger]')
  );
  if (!triggers.length) return;

  var current = 0;
  var lastFocused = null;

  var box = document.createElement('div');
  box.className = 'lightbox';
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-modal', 'true');
  box.setAttribute('aria-label', 'Artwork viewer');
  box.innerHTML =
    '<span class="lightbox__count"></span>' +
    '<button type="button" class="lightbox__btn lightbox__close" aria-label="Close">&#10005;</button>' +
    '<button type="button" class="lightbox__btn lightbox__prev" aria-label="Previous">&#8249;</button>' +
    '<img class="lightbox__img" alt="">' +
    '<button type="button" class="lightbox__btn lightbox__next" aria-label="Next">&#8250;</button>' +
    '<p class="lightbox__caption"></p>';
  document.body.appendChild(box);

  var img = box.querySelector('.lightbox__img');
  var caption = box.querySelector('.lightbox__caption');
  var count = box.querySelector('.lightbox__count');
  var btnClose = box.querySelector('.lightbox__close');
  var btnPrev = box.querySelector('.lightbox__prev');
  var btnNext = box.querySelector('.lightbox__next');

  function show(i) {
    current = (i + triggers.length) % triggers.length;
    var t = triggers[current];
    img.classList.remove('is-in');
    img.onload = function () {
      img.classList.add('is-in');
    };
    img.src = t.getAttribute('data-full');
    if (img.complete && img.naturalWidth) img.classList.add('is-in');
    img.alt = t.getAttribute('data-caption') || '';
    caption.textContent = t.getAttribute('data-caption') || '';
    count.textContent = pad(current + 1) + ' / ' + pad(triggers.length);
  }

  function open(i) {
    lastFocused = document.activeElement;
    show(i);
    box.classList.add('is-open');
    document.body.classList.add('lightbox-open');
    btnClose.focus();
  }

  function close() {
    box.classList.remove('is-open');
    document.body.classList.remove('lightbox-open');
    img.src = '';
    if (lastFocused) lastFocused.focus();
  }

  triggers.forEach(function (t, i) {
    t.addEventListener('click', function () {
      open(i);
    });
  });

  btnClose.addEventListener('click', close);
  btnPrev.addEventListener('click', function () {
    show(current - 1);
  });
  btnNext.addEventListener('click', function () {
    show(current + 1);
  });

  box.addEventListener('click', function (e) {
    if (e.target === box) close();
  });

  document.addEventListener('keydown', function (e) {
    if (!box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(current - 1);
    if (e.key === 'ArrowRight') show(current + 1);
  });

  /* Plate ticker ----------------------------------------------------------
     A small fixed catalogue readout that names the plate nearest centre. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var maxPlate = 0;
    var plateOf = function (el) {
      var m = /PL\.\s*(\d+)/.exec(el.getAttribute('data-caption') || '');
      return m ? parseInt(m[1], 10) : 0;
    };
    triggers.forEach(function (t) {
      maxPlate = Math.max(maxPlate, plateOf(t));
    });
    if (!maxPlate) return;

    var tick = document.createElement('div');
    tick.className = 'plate-ticker';
    tick.setAttribute('aria-hidden', 'true');
    tick.innerHTML = 'PL. <span class="plate-ticker__no">—</span>&nbsp;/&nbsp;' + maxPlate;
    document.body.appendChild(tick);
    var no = tick.querySelector('.plate-ticker__no');

    var tio = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var p = plateOf(entry.target);
          if (!p) return;
          no.textContent = pad(p);
          tick.classList.add('is-on');
          tick.classList.remove('is-pulse');
          void tick.offsetWidth;
          tick.classList.add('is-pulse');
        });
      },
      { rootMargin: '-42% 0px -42% 0px', threshold: 0 }
    );
    triggers.forEach(function (t) {
      tio.observe(t);
    });
  })();

  /* Gallery cursor --------------------------------------------------------
     A lagging red ring that swells over anything zoomable. Fine pointers
     only; the native cursor stays. */
  (function () {
    if (reduceMotion.matches) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;

    var ring = document.createElement('div');
    ring.className = 'cursor-ring';
    ring.setAttribute('aria-hidden', 'true');
    document.body.appendChild(ring);

    var mx = -100, my = -100, cx = -100, cy2 = -100, raf = null;

    function loop() {
      cx += (mx - cx) * 0.18;
      cy2 += (my - cy2) * 0.18;
      ring.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy2.toFixed(1) + 'px,0) translate(-50%,-50%)';
      if (Math.abs(mx - cx) + Math.abs(my - cy2) > 0.2) {
        raf = requestAnimationFrame(loop);
      } else {
        raf = null;
      }
    }

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
      ring.classList.add('is-on');
      if (raf === null) raf = requestAnimationFrame(loop);
    }, { passive: true });

    document.addEventListener('mouseleave', function () {
      ring.classList.remove('is-on');
    });

    document.addEventListener('mouseover', function (e) {
      if (e.target.closest('[data-lightbox-trigger]')) {
        ring.classList.add('is-zoom');
        ring.classList.remove('is-link');
      } else if (e.target.closest('a, button, summary, input, select')) {
        ring.classList.add('is-link');
        ring.classList.remove('is-zoom');
      } else {
        ring.classList.remove('is-zoom', 'is-link');
      }
    });
  })();
})();
